import { TriangleAlert } from "lucide-react";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useRouteError } from "react-router";

import { EmptyState } from "@/components/common/EmptyState";
import { Button } from "@/components/ui/button";

/** Shown when a route throws while rendering or loading. */
export function RouteErrorPage() {
  const { t } = useTranslation();
  const error = useRouteError();

  useEffect(() => {
    console.error(error);
  }, [error]);

  return (
    <div className="flex min-h-dvh items-center justify-center">
      <EmptyState
        icon={TriangleAlert}
        title={t("error.title")}
        description={t("error.description")}
        action={<Button onClick={() => window.location.reload()}>{t("error.reload")}</Button>}
      />
    </div>
  );
}
